class StylistEcommerce {
  constructor() {
    this.uniqueCode = "";
    this.envCode = "staging";
    this.apiUrls = {};
    this.init();
  }

  init() {
    this.getUrlParams();
    this.setupApiUrls();
    (this.urlColors.primary || this.urlColors.secondary || this.urlColors.tertiary) && this.applyUrlColors();
    this.setupEventListeners();
    this.fetchStylistData();
    this.setupLoader();
  }

  getUrlParams() {
    const urlParams = new URLSearchParams(window.location.search);
    this.uniqueCode = urlParams.get("stylist_unique_code");
    this.envCode = urlParams.get("env") || "staging";
    this.urlColors = {
      primary: urlParams.get("primary_color"),
      secondary: urlParams.get("secondary_color"),
      tertiary: urlParams.get("tertiary_color"),
    };
  }

  setupApiUrls() {
    const isProduction = this.envCode === "production";
    const baseApi = isProduction ? "https://api.unwritten.hair" : `https://api-${this.envCode}.unwritten.hair`;
    const baseBooking = isProduction ? "https://bookings.unwritten.hair" : `https://${this.envCode}-bookings.unwritten.hair`;
    this.apiUrls = {
      customerConnect: `${baseApi}/api/v1/shopify-customer-connect/`,
      stylistLocation: `${baseApi}/api/v1/stylist-location/?stylist_unique_code=${this.uniqueCode}`,
      mobileBooking: `${baseApi}/api/v1/bookings/mobile/schedule/${this.uniqueCode}/`,
      bookingUrl: `${baseBooking}/${this.uniqueCode}`,
    };
  }

  setupEventListeners() {
    document.body.addEventListener("click", (e) => this.handleBodyClick(e));
    $(document).on("click", ".custom_brand_nav li", (e) => this.handleBrandNavigation(e));
    $(document).on("click", ".ref-load-more-btn", (e) => this.handleLoadMore(e));
    $(document).on("click", ".product--quick-add", (e) => this.handleQuickAdd(e));
    $(document).on(
      "click",
      ".product--image-wrapper, .product--title, .product--details-wrapper, .product--price-container, .product--price-wrapper, .product--details",
      (e) => { e.preventDefault(); }
    );
    this.setupSearch();
  }

  setupSearch() {
    const searchHtml = `
      <div class="ref-search-wrap" style="padding:0.75rem 0 1rem;">
        <div style="position:relative;max-width:400px;margin:0 auto;">
          <input
            id="ref-product-search"
            type="search"
            placeholder="Search products…"
            autocomplete="off"
            style="
              width:100%;
              box-sizing:border-box;
              padding:0.6rem 2.5rem 0.6rem 1rem;
              border:1px solid #ddd;
              border-radius:100px;
              font-size:0.9rem;
              font-family:Manrope,sans-serif;
              outline:none;
              background:#fff;
            "
          />
          <svg style="position:absolute;right:0.9rem;top:50%;transform:translateY(-50%);width:16px;height:16px;opacity:0.4;pointer-events:none;" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
          </svg>
        </div>
      </div>
    `;

    // Inject after brand nav, before the product section
    $(".custom_brand_nav").after(searchHtml);

    $(document).on("input", "#ref-product-search", (e) => {
      this.filterProducts(e.target.value.trim());
    });
  }

  filterProducts(query) {
    this.currentSearchQuery = query;
    const lower = query.toLowerCase();
    const $products = $(".featured-collection--grid .product--root");
    let visibleCount = 0;

    $products.each(function () {
      const title = ($(this).find(".product--title").text() || "").toLowerCase();
      const matches = !lower || title.includes(lower);
      $(this).toggle(matches);
      if (matches) visibleCount++;
    });

    // Show/hide no-results message
    let $noResults = $("#ref-no-results");
    if (visibleCount === 0 && lower) {
      if (!$noResults.length) {
        $(".featured-collection--grid").after(
          '<p id="ref-no-results" style="text-align:center;padding:2rem;color:#888;font-family:Manrope,sans-serif;">No products found for "<strong>' + query + '</strong>"</p>'
        );
      } else {
        $noResults.html('No products found for "<strong>' + query + '</strong>"').show();
      }
    } else {
      $noResults.hide();
    }
  }

  handleBodyClick(event) {
    if (event.target.classList.contains("quick-view")) {
      event.preventDefault();
      const productRoot = event.target.closest(".product--root");
      productRoot && this.showQuickView(productRoot);
    }
    if (event.target.classList.contains("close-button")) {
      event.preventDefault();
      const hiddenDiv = event.target.closest(".product--form-for-off-canvas");
      hiddenDiv && this.hideQuickView(hiddenDiv);
    }
    document.querySelectorAll('.product--form-for-off-canvas[style*="display: block"]').forEach((form) => {
      !form.contains(event.target) && !event.target.classList.contains("quick-view") && this.hideQuickView(form);
    });
  }

  showQuickView(productRoot) {
    const hiddenDiv = productRoot.querySelector(".product--form-for-off-canvas");
    const overlayDiv = document.querySelector(".ref-quick-views-overly");
    if (hiddenDiv) {
      hiddenDiv.style.display = "block";
      hiddenDiv.style.opacity = "1";
      document.body.classList.add("overly");
      overlayDiv && (overlayDiv.style.display = "block");
      if (!hiddenDiv.querySelector(".close-button")) {
        const closeButton = document.createElement("button");
        closeButton.textContent = "X";
        closeButton.classList.add("close-button");
        hiddenDiv.appendChild(closeButton);
      }
    }
  }

  hideQuickView(hiddenDiv) {
    const overlayDiv = document.querySelector(".ref-quick-views-overly");
    hiddenDiv.style.display = "none";
    hiddenDiv.style.opacity = "0";
    document.body.classList.remove("overly");
    overlayDiv && (overlayDiv.style.display = "none");
  }

  // --- Brand navigation with Load More ---

  handleBrandNavigation(e) {
    const url = $("a", e.currentTarget).attr("data-link");
    const $clickedLi = $(e.currentTarget);
    $clickedLi.siblings().removeClass("active");
    $clickedLi.addClass("active");
    // Clear search on brand switch
    $("#ref-product-search").val("");
    this.currentSearchQuery = "";
    $("#ref-no-results").hide();
    this.fetchCollectionPage(url, 1, true);
  }

  fetchCollectionPage(baseUrl, page, replace) {
    const $grid = $(".featured-collection--grid");

    // Show a loading state on the grid only for the initial (replace) load
    if (replace) {
      $grid.css("opacity", "0.5");
    }

    $.ajax({
      url: `${baseUrl}?page=${page}`,
      success: (html) => {
        const $doc = $(html);
        const gridHtml = $doc.find(".collection--body--grid").html() || "";

        // Remove any existing Load More button before updating the grid
        $grid.find(".ref-load-more-wrap").remove();

        if (replace) {
          $grid.html(gridHtml);
          $grid.css("opacity", "1");
        } else {
          $grid.append(gridHtml);
        }

        // Re-init Stamped review badges for newly injected products
        setTimeout(() => {
          typeof StampedFn !== "undefined" && StampedFn.reloadUGC();
        }, 800);

        // Re-apply active search filter to newly loaded products
        if (this.currentSearchQuery) {
          this.filterProducts(this.currentSearchQuery);
        }

        // Inject Load More button if there's a next page
        const hasNextPage = $doc.find('a.pagination--link[aria-label="Next"][href]').length > 0;
        if (hasNextPage) {
          const loaded = $grid.find(".product--root").length;
          const total = parseInt($doc.find(".collection--products-count").text()) || null;
          const countLabel = total ? `Showing ${loaded} of ${total}` : `${loaded} products loaded`;

          $grid.append(`
            <div class="ref-load-more-wrap" style="grid-column:1/-1;text-align:center;padding:2rem 0 1rem;">
              <p class="ref-load-more-count" style="margin:0 0 0.75rem;font-size:0.85rem;color:#888;">${countLabel}</p>
              <button
                class="ref-load-more-btn stylist-ecommerce-btn stylist-ecommerce-btn--primary"
                data-url="${baseUrl}"
                data-page="${page + 1}"
                style="min-width:160px;text-align:center;"
              >
                Load More
              </button>
            </div>
          `);
        }
      },
      error: () => {
        $grid.css("opacity", "1");
      },
    });
  }

  handleLoadMore(e) {
    const $btn = $(e.currentTarget);
    const url = $btn.data("url");
    const page = parseInt($btn.data("page"));

    // Disable button while loading
    $btn.text("Loading…").prop("disabled", true).css("opacity", "0.6");

    this.fetchCollectionPage(url, page, false);
  }

  // --- Quick add to cart ---

  handleQuickAdd(e) {
    e.preventDefault();
    const $btn = $(e.currentTarget);
    $btn.attr("data-loading", "true");
    const variantId = $btn.attr("v_id");
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: { id: variantId },
      dataType: "json",
      success: () => { setTimeout(() => { $btn.attr("data-loading", "false"); }, 200); },
      error: () => { $btn.attr("data-loading", "false"); },
    });
  }

  // --- Stylist data ---

  async fetchStylistData() {
    try {
      const data = await (
        await fetch(
          `${this.apiUrls.customerConnect}?${new URLSearchParams({
            stylist_unique_code: this.uniqueCode,
            shopify_consumer_id: ShopifyAnalytics.meta.page.customerId,
          })}`
        )
      ).json();

      data.data?.business_details?.theme_colors && (
        console.log("Applying theme colors from API:", data.data.business_details.theme_colors),
        this.applyThemeColors(data.data.business_details.theme_colors)
      );
      data.data?.business_details?.hidden_brand_handles && this.hideBrands(data.data.business_details.hidden_brand_handles);
      this.populateStylistInfo(data.data);
      await this.handleBookingVisibility();
      await this.fetchLocationData();
    } catch (error) {
      console.error("Error fetching stylist data:", error);
    }
  }

  hideBrands(hiddenHandles) {
    if (!hiddenHandles || hiddenHandles.length === 0) return;
    hiddenHandles.forEach((handle) => {
      const brandLink = document.querySelector(`.brand-link--${handle}`);
      brandLink && (brandLink.style.display = "none");
    });
    console.log("Hidden brands:", hiddenHandles);
    const firstVisibleBrand = document.querySelector('.brand-link:not([style*="display: none"])');
    firstVisibleBrand && $(firstVisibleBrand).trigger("click");
  }

  populateStylistInfo(data) {
    const businessDetails = data.business_details || {};
    const displayName = businessDetails.display_name || data.full_name;

    document.getElementById("prsn").innerHTML = data.full_name;
    document.getElementById("buy-from-title").innerHTML = `Buy from ${displayName}`;
    document.getElementById("about-title").innerHTML = `About ${displayName}`;
    document.getElementById("why-connect-prsn-name").innerHTML = displayName;
    document.getElementById("address").innerHTML = data.address;
    document.getElementById("main-online-booking-link").href = this.apiUrls.bookingUrl;
    document.getElementById("book-me-now").href = data.online_booking_profile;
    document.getElementById("prsn-desc").innerHTML = data.description;

    const logoUrl = businessDetails.logo || data.profile_pic;
    if (logoUrl) {
      const logoElement = document.getElementById("prsn-logo");
      logoElement.src = logoUrl;
      logoElement.style.width = "80px";
      logoElement.style.height = "80px";
      logoElement.style.objectFit = "cover";
    }

    const featuredImages = businessDetails.featured_images || [];
    const galleryColOne = document.querySelector(".stylist-ecommerce-hero__gallery-col--one img");
    const galleryColTwo = document.querySelectorAll(".stylist-ecommerce-hero__gallery-col--two img");

    if (featuredImages[0] && galleryColOne) {
      galleryColOne.src = featuredImages[0];
      galleryColOne.style.width = "414px";
      galleryColOne.style.height = "414px";
      galleryColOne.style.objectFit = "cover";
    }
    if (featuredImages[1] && galleryColTwo[0]) {
      galleryColTwo[0].src = featuredImages[1];
      galleryColTwo[0].style.width = "191px";
      galleryColTwo[0].style.height = "191px";
      galleryColTwo[0].style.objectFit = "cover";
    }
    if (featuredImages[2] && galleryColTwo[1]) {
      galleryColTwo[1].src = featuredImages[2];
      galleryColTwo[1].style.width = "191px";
      galleryColTwo[1].style.height = "191px";
      galleryColTwo[1].style.objectFit = "cover";
    }
  }

  async handleBookingVisibility() {
    try {
      const [stylistBookingData, mobileBookingData] = await Promise.all([
        fetch(this.apiUrls.stylistLocation).then((r) => r.json()),
        fetch(this.apiUrls.mobileBooking).then((r) => r.json()),
      ]);

      stylistBookingData.stylist_info.hide_business_phone
        ? (document.getElementById("idMobilePhone").style.display = "none")
        : (document.getElementById("idMobilePhone").href = `tel:${stylistBookingData.stylist_info.mobile_number}`);

      const isMobileDaysActive = mobileBookingData.data.some((item) => item.is_active);
      const hasLocations = stylistBookingData.results.length > 0;
      const allowsConsumerAddress = stylistBookingData.stylist_info.is_consumer_preferred_address_allowed;

      if ((!isMobileDaysActive && !hasLocations) || (!allowsConsumerAddress && !hasLocations)) {
        document.getElementById("idBookOnlineButtonContainer").style.display = "none";
        document.getElementById("main-online-booking-link").style.setProperty("display", "none", "important");
      } else {
        document.getElementById("main-online-booking-link").href = this.apiUrls.bookingUrl;
        document.getElementById("book-me-now").href = this.apiUrls.bookingUrl;
      }
    } catch (error) {
      console.error("Error handling booking visibility:", error);
    }
  }

  async fetchLocationData() {
    try {
      const data = await (await fetch(this.apiUrls.stylistLocation)).json();
      data.status.code === 200 && data.results.length > 0 && this.displayLocations(data.results, data.stylist_info);
    } catch (error) {
      console.error("Error fetching location data:", error);
    }
  }

  displayLocations(locations, stylistInfo) {
    const container = document.getElementById("location-container");
    container.innerHTML = "";
    locations.forEach((location) => {
      const activeHours = location.working_hours.filter((hour) => hour.is_active);
      const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(location.address)}`;
      const availabilityTiming = activeHours
        .map((hour) => `${this.getWeekdayName(hour.weekday)} ${this.convertToAmPm(hour.start_time)} - ${this.convertToAmPm(hour.end_time)}`)
        .join("<br>");
      const socialLinks = this.generateSocialLinks(stylistInfo);
      const locationHTML = `
        <div class="stylist-ecommerce-locations__container">
          <div class="stylist-ecommerce-locations__box" style="margin-bottom: 15px;">
            <div class="stylist-ecommerce-locations__card">
              <div class="stylist-ecommerce-locations__info">
                <h3 class="text-secondary">${location.name}</h3>
                <p class="text-black">${location.address}</p>
                <a id="hairdressor-direction" href="${googleMapsUrl}" target="_blank" rel="noopener">Get directions</a>
              </div>
              <div class="stylist-ecommerce-locations__contact">
                ${stylistInfo.hide_business_phone ? "" : `<a href="tel:${stylistInfo.mobile_number}" id="hairdressor-phone" class="text-black">${stylistInfo.mobile_number}</a>`}
                ${stylistInfo.hide_business_email ? "" : `<a href="mailto:${stylistInfo.email}" id="hairdressor-email" class="text-black">${stylistInfo.email}</a>`}
              </div>
              <div class="stylist-ecommerce-locations__hours">
                <h3 id="hairdressor-availability" class="text-secondary">Open hours</h3>
                <p id="hairdressor-availability-timing" class="text-black">${availabilityTiming}</p>
              </div>
              <div class="stylist-ecommerce-locations__social">
                <ul>${socialLinks}</ul>
              </div>
            </div>
          </div>
        </div>
      `;
      container.insertAdjacentHTML("beforeend", locationHTML);
    });
  }

  generateSocialLinks(stylistInfo) {
    let links = "";
    const primaryColor = getComputedStyle(document.documentElement).getPropertyValue("--referral-secondary").trim();

    stylistInfo.facebook_handle && (links += `
      <li><a href="https://facebook.com/${stylistInfo.facebook_handle}" target="_blank" rel="noopener" aria-label="Facebook">
        <svg width="37" height="35" viewBox="0 0 37 35" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.08643 17.5032C3.08822 24.6773 8.60313 30.7857 16.0935 31.9101V21.7178H12.1823V17.5032H16.0981V14.2949C15.923 12.7746 16.472 11.2595 17.596 10.1604C18.7201 9.06131 20.3028 8.49218 21.9148 8.60737C23.0719 8.62505 24.2261 8.72253 25.3681 8.89904V12.4851H23.4195C22.7486 12.402 22.0741 12.6116 21.5861 13.0548C21.098 13.4981 20.8492 14.127 20.9096 14.7645V17.5032H25.1816L24.4986 21.7192H20.9096V31.9101C29.0103 30.6991 34.6907 23.7008 33.8358 15.9852C32.9808 8.26958 25.8897 2.53769 17.6996 2.94201C9.50957 3.34633 3.08773 9.74532 3.08643 17.5032Z" fill="${primaryColor}"/>
        </svg>
      </a></li>
    `);

    stylistInfo.instagram_handle && (links += `
      <li><a href="https://www.instagram.com/${stylistInfo.instagram_handle}" target="_blank" rel="noopener" aria-label="Instagram">
        <svg width="36" height="35" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334" fill="${primaryColor}"/>
        </svg>
      </a></li>
    `);

    stylistInfo.tiktok_handle && (links += `
      <li><a href="https://www.tiktok.com/@${stylistInfo.tiktok_handle}" target="_blank" rel="noopener" aria-label="TikTok">
        <svg width="36" height="35" viewBox="0 0 36 35" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22.5 4.375C22.5 5.77083 22.9479 7.07812 23.7292 8.14583C24.5104 9.21354 25.5833 10 26.875 10V13.75C25.0729 13.75 23.4062 13.2292 21.9792 12.3125V21.875C21.9792 25.5417 19 28.5208 15.3333 28.5208C11.6667 28.5208 8.6875 25.5417 8.6875 21.875C8.6875 18.2083 11.6667 15.2292 15.3333 15.2292V19.0625C13.5625 19.0625 12.125 20.5 12.125 22.2708C12.125 24.0417 13.5625 25.4792 15.3333 25.4792C17.1042 25.4792 18.5417 24.0417 18.5417 22.2708V4.375H22.5Z" fill="${primaryColor}"/>
        </svg>
      </a></li>
    `);

    return links;
  }

  convertToAmPm(time) {
    const [hours, minutes] = time.split(":").map(Number);
    const ampm = hours >= 12 ? "PM" : "AM";
    return `${hours % 12 || 12}:${minutes.toString().padStart(2, "0")} ${ampm}`;
  }

  getWeekdayName(weekday) {
    return ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"][weekday];
  }

  applyThemeColors(colors) {
    colors.primary && document.documentElement.style.setProperty("--referral-primary", colors.primary);
    colors.secondary && document.documentElement.style.setProperty("--referral-secondary", colors.secondary);
    colors.tertiary && document.documentElement.style.setProperty("--referral-tertiary", colors.tertiary);
  }

  applyUrlColors() {
    const colors = {};
    this.urlColors.primary && (colors.primary = this.urlColors.primary.startsWith("#") ? this.urlColors.primary : `#${this.urlColors.primary}`);
    this.urlColors.secondary && (colors.secondary = this.urlColors.secondary.startsWith("#") ? this.urlColors.secondary : `#${this.urlColors.secondary}`);
    this.urlColors.tertiary && (colors.tertiary = this.urlColors.tertiary.startsWith("#") ? this.urlColors.tertiary : `#${this.urlColors.tertiary}`);
    this.applyThemeColors(colors);
    console.log("Applied URL colors:", colors);
  }

  setupLoader() {
    $(window).on("load", () => {
      setTimeout(() => { $(".ref-page-loader").fadeOut("slow"); }, 500);
    });
  }
}

document.addEventListener("DOMContentLoaded", () => { new StylistEcommerce(); });
$(document).ready(() => { $("nav.brand-navigation ul li:first-child").trigger("click"); });